import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{! template-lint-disable no-bare-strings }}\n\n<SiteWrapper::Breadcrumb @label=\'Other\' @route=\'routes/styleguide.other\' />")